import { render, staticRenderFns } from "./GPTData.vue?vue&type=template&id=0d0719a5&"
import script from "./GPTData.vue?vue&type=script&lang=ts&"
export * from "./GPTData.vue?vue&type=script&lang=ts&"
import style0 from "./GPTData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports